/* Progressive enhancements; native links, details, and forms work without JS. */
(() => {
  const prepareCustomizer = (link) => {
    const form = link.closest('form');
    const variant = form?.querySelector('[name="id"]')?.value || link.dataset.variantId;
    const root = link.dataset.storeRoot.replace(/\/$/, '');
    const url = new URL(root + (window.zakekeUrl || '/apps/zakeke'), window.location.origin);
    url.searchParams.set('pid', link.dataset.productId);
    if (variant) url.searchParams.set('id', variant);
    link.href = url.toString();
    return link.href;
  };
  document.addEventListener('submit', (event) => {
    const link = event.target.querySelector('[data-bob-zakeke]');
    if (!link) return;
    event.preventDefault();
    event.stopImmediatePropagation();
    window.location.assign(prepareCustomizer(link));
  }, true);
  document.addEventListener('click', (event) => {
    const target = event.target instanceof Element ? event.target : null;
    const customizer = target?.closest('[data-bob-zakeke]');
    if (customizer) prepareCustomizer(customizer);
    const audience = target?.closest('[data-bob-audience]');
    if (audience) {
      const field = document.querySelector('[data-bob-audience-field]');
      if (field && [...field.options].some(option => option.value === audience.dataset.bobAudience)) {
        field.value = audience.dataset.bobAudience;
        field.dispatchEvent(new Event('change', { bubbles: true }));
      }
    }
    if (target?.closest('.bob-mobile-nav a')) target.closest('.bob-mobile-nav').open = false;
  });
  document.addEventListener('keydown', (event) => {
    if (event.key !== 'Escape') return;
    document.querySelectorAll('.bob-mobile-nav[open]').forEach(menu => {
      menu.open = false;
      menu.querySelector('summary')?.focus();
    });
  });
})();
